var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { InfluencerSuggestionState } from '../../../../models/influencer-suggestion';
import { GroupService } from '../../../services/group-details/group.service';
import { CampaignService } from '../../../services/campaign/campaign.service';
import { TranslateService } from '@ngx-translate/core';
import { AddInfluencerGroupComponent } from '../../group-details/add-influencer-group/add-influencer-group.component';
import { UserService } from '../../../services/user.service';
import { ModalService } from '../../../services/modal/modal.service';
import { CommonConstant } from '../../../app.constants';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { EventTrackerService } from '../../../services/event-tracker/event-tracker.service';
var AddInfluencerCampaignComponent = /** @class */ (function (_super) {
    __extends(AddInfluencerCampaignComponent, _super);
    function AddInfluencerCampaignComponent(campaignService, groupService2, userService, modalService, influencerService, translate, eventTracker) {
        var _this = _super.call(this, groupService2, userService, translate, influencerService, eventTracker, modalService) || this;
        _this.campaignService = campaignService;
        _this.groupService2 = groupService2;
        _this.userService = userService;
        _this.modalService = modalService;
        _this.influencerService = influencerService;
        _this.translate = translate;
        _this.eventTracker = eventTracker;
        _this.isAddImmediately = true;
        _this.addInfluencerAsAccepted = false;
        _this.eventAddInfluencerToCampaigns = new EventEmitter();
        return _this;
    }
    AddInfluencerCampaignComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        if (this.initializeInfluencerList && this.initializeInfluencerList.length > 0) {
            var addedInfluencerIds_1 = this.selectedInfluencers.map(function (si) { return si.influencerId; });
            this.initializeInfluencerList.forEach(function (infl) {
                if (addedInfluencerIds_1.indexOf(infl.influencerId) < 0) {
                    _this.selectedInfluencers.push(infl);
                }
            });
            this.addInfluencerAsAccepted = this.initializeInfluencerList.filter(function (influencer) {
                return influencer.status.toLowerCase() !== CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name.toLowerCase();
            }).length === 0;
        }
    };
    AddInfluencerCampaignComponent.prototype.selectInfluencerSuggestion = function (influencer) {
        _super.prototype.selectInfluencerSuggestion.call(this, influencer);
    };
    AddInfluencerCampaignComponent.prototype.closeAddInfluencerToCampaign = function (evt) {
        this.closeConfirmationPopup();
        this.closeFragmentEvent.emit({
            resetSelectedInfluencer: true
        });
    };
    AddInfluencerCampaignComponent.prototype.validateInfluencerListBeforeAddToCampaign = function () {
        var incompletedInfluencers = this.selectedInfluencers.filter(function (infl) { return infl.state === InfluencerSuggestionState.NOT_FOUND; });
        if (incompletedInfluencers.length > 0) {
            this.modalService.openInCenter(this.warningForAddingNewInfluencer);
        }
        else {
            this.addInfluencerToCampaign();
        }
    };
    AddInfluencerCampaignComponent.prototype.addNewInfluencer = function (evt) {
        this.addNewInfluencerManuallyEvent.emit({
            handle: evt.handle,
            processingIndex: evt.index,
            influencerSuggestion: evt.influencer,
            selectedInfluencers: this.selectedInfluencers,
            addInfluencerAsAccepted: this.addInfluencerAsAccepted
        });
    };
    AddInfluencerCampaignComponent.prototype.addInfluencerToCampaign = function () {
        var _this = this;
        var campaignInfluencers = this.selectedInfluencers.filter(function (inf) { return inf.influencerId > 0; })
            .map(function (influencer) { return Object.assign({}, influencer, {
            influencer_id: influencer.influencerId,
            action: 'add',
            status: _this.addInfluencerAsAccepted ? CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name : ''
        }); });
        if (!this.isAddImmediately) {
            this.eventAddInfluencerToCampaigns.emit(campaignInfluencers);
        }
        else {
            var influencerToAdd = {
                influencers: campaignInfluencers,
                campaign_id: this.campaign.id
            };
            this.eventAddInfluencerToCampaigns.emit(influencerToAdd);
        }
    };
    return AddInfluencerCampaignComponent;
}(AddInfluencerGroupComponent));
export { AddInfluencerCampaignComponent };



// WEBPACK FOOTER //
// ./src/app/main/campaigns/add-influencer-campaign/add-influencer-campaign.component.ts.pre-build-optimizer.js